import { render, staticRenderFns } from "./DayTable.vue?vue&type=template&id=06173b71&scoped=true&"
import script from "./DayTable.vue?vue&type=script&lang=js&"
export * from "./DayTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06173b71",
  null
  
)

export default component.exports